import { Heading } from "@sidelinesports/fan-design-system";
import type { ApiGameDetails } from "../../../../api";
import { getGameShortTitle } from "../../../../utils";

export const GameTitle = ({ game }: { game: ApiGameDetails }) => {
  return (
    <Heading as="div" level={4}>
      {getGameShortTitle(game)}
    </Heading>
  );
};
